import { createQueryKeys } from '@lukemorales/query-key-factory';
import { EQueryKeys } from 'common/enums/query-kyes.enum';
import { getPermissionsListService } from '../services/permissions.service';
import { TGetPermissionsListParams, TGetPermissionsListResData } from '../types/permissions.types';

export const permissionsQueryKeys = createQueryKeys(EQueryKeys.PermissionQueryKeys, {
  getPermissionsList: (params: TGetPermissionsListParams) => ({
    queryKey: ['get-permisssions-list', params],
    queryFn: (): Promise<TGetPermissionsListResData> => getPermissionsListService(params),
  }),
});
